export const pad = (n: string, str = '000') => {
  return (str + n).slice(-str.length);
};

export default { pad };
